import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Modal, Spin } from "antd";
import styles from "./Credit.module.css";
import InfiniteScroll from "react-infinite-scroller";
import { Page, Uniter } from "../../../../helbest";
// import { API } from "../../../../request/api";
import CreditFilterSidebar from "./CreditFilterSidebar/CreditFilterSidebar";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import CreditSortModal from "./CreditSortModal/CreditSortModal";
// svgs
import { ReactComponent as EmptyBoxIcon } from "../../../../assets/svg/empty-box.svg";
import { ReactComponent as WalletIcon } from "../../../../assets/svg/footer-wallet.svg";
import { ReactComponent as FilterIcon } from "../../../../assets/svg/filter.svg";
// import { ReactComponent as RisingIcon } from "../../../../assets/svg/rising.svg";
// import { ReactComponent as FallingIcon } from "../../../../assets/svg/falling.svg";
import useFilter from "./useFilter";
import Button from "../../../components/ui/Button";
import { useMeQuery } from "../../../../saleor/api";
import { mapEdgesToNodes } from "../../../../base/utils";
import { set_credit } from "../../../../store/actions/login_actions";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

export const sort_list = [
  { label: "the newest", value: 1, key: "-created_at" },
  { label: "Rising Price", value: 2, key: "amount" },
  { label: "Falling Price", value: 3, key: "-amount" },
];

export const types_list = [
  { label: "all", key: "all", value: 1 },
  { label: "Rising", key: "increase", value: 2 },
  { label: "Falling", key: "decrease", value: 3 },
];

const Credit = (props) => {
  const dispatch = useDispatch();
  const Login = useSelector((state) => state.Login);
  const [filter_open, set_filter_open] = useState(false);
  const { t } = useTranslation();
  const navigate = useLangNavigate();

  const { data: profileData } = useMeQuery({
    variables: {},
    skip: !Login.token,
  });

  useEffect(() => {
    if (profileData) {
      const credit = mapEdgesToNodes(profileData.me.giftCards.edges).find(
        (giftCard) =>
          giftCard.metadata.find(
            (meta) => meta.value.toLowerCase() === "wallet"
          )
      )?.currentBalance?.amount;
      dispatch(set_credit(credit));
    }
    // eslint-disable-next-line
  }, [profileData]);

  const [
    type,
    set_type,
    price_from,
    set_price_from,
    price_to,
    set_price_to,
    date_from,
    set_date_from,
    date_to,
    set_date_to,
    sort_visible,
    set_sort_visible,
    sort_value,
    set_sort_value,
    filtered_list,
    submit_filter,
    next,
    loading,
    set_loading,
  ] = useFilter();

  const check_user = () => {
    if (!props.Login.is_login) {
      navigate("/login/d/");
    }
  };

  useEffect(() => {
    check_user();
    // eslint-disable-next-line
  }, [props.Login.is_login]);

  return (
    <Page
      className="page-profile credit-page"
      back={true}
      address="/profile/"
      showFooter
      mobileContainer
      customHeader={<HeaderBack title={t("transaction.title")} />}
      headerFix
      logo
    >
      <div className="credit-header-container">
        <div className={"credit-header"}>
          <div className={"credit-money-container"}>
            <div className="my-credit-container">
              <WalletIcon className={"wallet-icon"} />
              <span className="mr-1 ml-1">{t("wallet.my")}:</span>
            </div>
            <Uniter unit="OMR" isBold>
              {Login.credit || 0}
            </Uniter>
          </div>
        </div>
        {filtered_list && filtered_list.length > 0 && loading && (
          <div className={"filter-container"}>
            <div
              style={{ minWidth: "150px" }}
              className={"filter-container-filter-button"}
            >
              <Button
                style_width="100%"
                style_backgroundColor="white"
                style_backgroundColor_hover="white"
                style_backgroundColor_active="white"
                // style_border={
                //     "1px solid var(--hig-color-secondary)"
                // }
                // style_border_hover={
                //     "1px solid var(--hig-color-secondary)"
                // }
                // style_border_active={
                //     "1px solid var(--hig-color-secondary)"
                // }
                style_color={"var(--hig-color-secondary)"}
                style_color_hover={"var(--hig-color-secondary)"}
                style_color_active={"var(--hig-color-secondary)"}
                style_marginRight={8}
                style_paddingLeft={8}
                style_borderRadius={"10px"}
                style_paddingRight={8}
                style_fontSize="type-3"
                onClick={() => set_filter_open(!filter_open)}
                className={"filter-button"}
              >
                <FilterIcon />
                <span>Filter</span>
              </Button>
              <CreditFilterSidebar
                sidebar_open={filter_open}
                set_sidebar_open={set_filter_open}
                type={type}
                set_type={set_type}
                price_from={price_from}
                set_price_from={set_price_from}
                price_to={price_to}
                set_price_to={set_price_to}
                date_from={date_from}
                set_date_from={set_date_from}
                date_to={date_to}
                set_date_to={set_date_to}
                submit_filter={submit_filter}
                sort_visible={sort_visible}
                set_sort_visible={set_sort_visible}
                sort_value={sort_value}
                set_sort_value={set_sort_value}
                set_loading={set_loading}
                next={next}
              />
            </div>
            <div className={"filter-container-sort-button"}>
              <Button
                style_width="100%"
                style_marginRight={8}
                style_backgroundColor="white"
                style_color="type-text-1"
                style_fontSize="type-3"
                style_paddingTop="type-0"
                style_paddingBottom="type-0"
                style_paddingLeft="type-1"
                style_paddingRight="type-1"
                style_borderRadius={"10px"}
                onClick={() => set_sort_visible(true)}
                className={"sort-button"}
              >
                <div>
                  <span className="sort-text">
                    Sort{" "}
                    <span className="sort-item">
                      (
                      {
                        sort_list.find(
                          (sort_item) => sort_item.value === sort_value
                        )?.label
                      }
                      )
                    </span>
                  </span>
                </div>
              </Button>
              <Modal
                closable={true}
                onCancel={() => set_sort_visible(false)}
                open={sort_visible}
                footer={false}
              >
                <CreditSortModal
                  sort_visible={sort_visible}
                  set_sort_visible={set_sort_visible}
                  sort_value={sort_value}
                  set_sort_value={set_sort_value}
                  submit_filter={submit_filter}
                />
              </Modal>
            </div>
          </div>
        )}
      </div>
      <div
        style={{ paddingBottom: "70px" }}
        className="container desktop-mode credit-scroller"
      >
        {!!filtered_list && filtered_list.length === 0 && !loading && (
          <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
            <EmptyBoxIcon className={styles.EmptyBoxIcon} />
            <div className={styles.EmptyText}>No Credits Found</div>
          </div>
        )}
        <div>
          <InfiniteScroll
            pageStart={1}
            loadMore={() => {
              if (next) {
                submit_filter(true);
              }
            }}
            hasMore={next !== null ? true : false}
            loader={
              <div key={0} className="auto-service-list-loading text-center">
                <Spin size="large" className={`red mt-4 ${styles.Spin}`} />
              </div>
            }
          >
            {filtered_list.map((x, i) => (
              <div
                key={i}
                style={{
                  borderRadius: 16,
                  border: "none",
                  boxShadow: `0px 0px 6px 1px rgba(0, 0, 0, 0.1)`,
                }}
                className="flex-r animated fadeIn credit-box"
              >
                {/* {x.state === "increase" ? (
                                    <RisingIcon className={styles.RisingIcon} />
                                ) : (
                                    <FallingIcon />
                                )} */}
                <div className="credit-box-container">
                  <p className="credit-box-title">{x.date}</p>
                  <div className="credit-box-list">
                    {x.orders &&
                      x.orders.map((order, orderIndex) => {
                        return (
                          <div
                            className={`flex-r ${
                              orderIndex !== 0 ? "mt-1" : ""
                            } flex-between credit-box-content`}
                          >
                            <p>{order.name}</p>

                            <div className="flex-r credit-box-unit">
                              <Uniter unit="OMR" childSize={12} isBold noTax>
                                {order.amount > 0
                                  ? `+${order.amount}`
                                  : order.amount}
                              </Uniter>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      </div>
    </Page>
  );
};
// class Credit extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       credit_list: [],
//       loading: true,
//       limit: 10,
//       next: null,
//       GTT: false,
//     };
//     this.check_user();
//   }

//   check_user() {
//     if (!this.props.Login.is_login) {
//       this.props.history.push("/login/d/");
//     }
//   }

//   componentDidMount() {
//     this.__GET();
//     window.onscroll = () => {
//       if (window.pageYOffset > 160) {
//         this.setState({ GTT: true });
//       } else {
//         this.setState({ GTT: false });
//       }
//     };
//   }

//   __GET() {
//     // GET PRODUCT
//     this.setState({ loading: true })
//     API.get.userCredits()
//       .then((response) => {
//         this.setState({
//           loading: false,
//           next: response.pagination.next,
//           credit_list: response.data,
//         });
//       })
//       .catch((error) => {
//         this.setState({ loading: false });
//         console.log("Error : ", error);
//       });
//   }

//   __load_more() {
//     // GET PRODUCT
//     API.get.userCredits(this.state.next, this.state.limit)
//       .then(async (Response) => {
//         if (Response.success) {
//           let list1 = this.state.credit_list;
//           let list2 = Response.data;
//           let list3 = list1.concat(list2);

//           await this.setState({
//             credit_list: list3,
//             loading: false,
//             next: Response.pagination.next,
//           });
//         } else {
//           this.setState({ loading: false });
//         }
//       })
//       .catch((error) => {
//         console.log("Error : ", error);
//         this.setState({ loading: false });
//       });
//   }

//   render() {
//     return (
//       <Page
//         className="page-profile credit-page"
//         title="تراکنش های اعتبار"
//         back={true}
//         address="/profile/"
//         showFooter
//         mobileContainer
//         headerFix
//         logo>
//         <div className="credit-header-container">
//           <div className={"credit-header"}>
//             <div className={"credit-money-container"}>
//               <div className="my-credit-container">
//                 <WalletIcon className={"wallet-icon"} />
//                 <span className="mr-1 ml-1">My Credit:</span>
//               </div>
//               <Uniter unit="OMR">{this.props.Login.credit}</Uniter>
//             </div>

//             {/* <CreditFilterSort
//               type={type}
//               set_type={set_type}
//               price_from={price_from}
//               set_price_from={set_price_from}
//               price_to={price_to}
//               set_price_to={set_price_to}
//               date_from={date_from}
//               set_date_from={set_date_from}
//               date_to={date_to}
//               set_date_to={set_date_to}
//               submit_filter={submit_filter}
//               sort_visible={sort_visible}
//               set_sort_visible={set_sort_visible}
//               sort_value={sort_value}
//               set_sort_value={set_sort_value}
//             /> */}
//           </div>
//         </div>
//         <div className="container desktop-mode credit-scroller">
//           {
//             (!!this.state.credit_list && this.state.credit_list.length === 0 && !this.state.loading) &&
//             <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
//               <EmptyBoxIcon className={styles.EmptyBoxIcon} />
//               <div className={styles.EmptyText}>اعتباری یافت نشد</div>
//             </div>
//           }
//           <div>
//             {this.state.loading ? (
//               <div className="text-center" style={{ marginTop: 20 }}>
//                 <Spin className={`red mt-2 ${styles.Spin}`} />
//               </div>
//             ) : null}

//             <InfiniteScroll
//               pageStart={1}
//               loadMore={() => this.__load_more()}
//               hasMore={this.state.next !== null ? true : false}
//               loader={
//                 <div key={0} className="auto-service-list-loading text-center">
//                   <Spin size="large" className={`red mt-4 ${styles.Spin}`} />
//                 </div>
//               }>
//               {this.state?.credit_list.map((x, i) => (
//                 <div
//                   key={i}
//                   className={
//                     x.state === "increase"
//                       ? "flex-r animated fadeIn credit-box credit-box-green m-2"
//                       : "flex-r animated fadeIn credit-box credit-box-red m-2"
//                   }>
//                   <p>{x.title}</p>

//                   <div className="flex-r mt-1 flex-between">
//                     <p className="text-black">{x.date}</p>

//                     <div className="flex-r text-black">
//                       <Uniter unit="OMR" className="">
//                         {x.amount}
//                       </Uniter>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </InfiniteScroll>
//           </div>
//         </div>
//       </Page>
//     );
//   }
// }

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(Credit);
